import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceService } from 'src/app/services/devices/device.service';

@Component({
    selector: 'app-nimble',
    imports: [CommonModule, FormsModule, TranslateModule],
    templateUrl: './nimble.component.html'
})
export class NimbleComponent implements OnInit {

      @Input()
      allSettings=false;

      device: string = '';
      successMessage: boolean = false;
      error: string= '';
      originalData: any;
      changesMade=false;
      cfgData: any = {};
      statData: any = {};

      constructor(private _aRoute: ActivatedRoute, public _deviceService : DeviceService) {

      }

      ngOnInit(): void {
        this._aRoute.parent?.parent?.params
        .subscribe((params: Params) => this.device = params['serial']);

        this._deviceService.getModuleInfo(this.device, "nimble").subscribe(data=>{
          console.log( 'Nimble data:', data);
          this.originalData={ ...data?.cfg }
          this.cfgData = data?.cfg;
          this.statData = data?.stat;
          console.log('nimble cfg ', this.cfgData);
          console.log('nimble stat ', this.statData);

        })
      }

      save(){}
}
